import { render, staticRenderFns } from "./AddTeacher.vue?vue&type=template&id=0fbe1c6f&scoped=true"
import script from "./AddTeacher.vue?vue&type=script&lang=js"
export * from "./AddTeacher.vue?vue&type=script&lang=js"
import style0 from "./AddTeacher.vue?vue&type=style&index=0&id=0fbe1c6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbe1c6f",
  null
  
)

export default component.exports